export default __webpack_public_path__ + "static/media/kangoo.4a56a20c.png";